<template>
        <v-container>
            <v-dialog v-model="dialogElimnar" max-width="400">
                <v-card>
                    <v-card-title class="headline">
                      {{$t('msg_emergencia')}}
                    </v-card-title>
                    <v-card-actions>
                      <v-btn
                          color="primary"
                          @click="dialogElimnar = false"
                      >
                        No
                      </v-btn>
                      <v-spacer/>
                      <v-btn
                          color="primary"
                          @click="send_alert"
                      >
                        {{$t('Si')}}
                      </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-layout align-center justify-center fill-height>
                <v-flex xs12 sm7 md6 lg5 xl3>
                    <v-card class="elevation-5">
                        <v-toolbar class="mb-5" dark color="red darken-4">
                            <v-toolbar-title>
                                {{ $t('emergencia')}} / {{ $t('evacuacion')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text align="center">
                            <v-form class="mb-4">
                                <v-label>
                                    {{$t('lbl_emergencia')}}
                                </v-label>
                                <br>
                                <v-alert
                                        :value=alerta
                                        type="warning"
                                        outline
                                        transition="scale-transition"
                                >
                                    {{ errores.non_field_errors }}
                                </v-alert>
                                <v-btn
                                        center
                                        :loading="loading"
                                        color="primary"
                                        :disabled="btn_disabled"
                                        @click="dialogElimnar = true"
                                >{{$t('enviar')}}
                                </v-btn>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'

    export default {
        name: "emergencia",
        data: () => ({
            show: false,
            alerta: false,
            mensaje: '',
            password: '',
            errores: [],
            loading: false,
            dialogElimnar: false,
            btn_disabled: false
        }),
        methods:{
            send_alert(){
                this.dialogElimnar = false
                this.$store.commit('snackbar_activate_true')
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_change_message', this.$t('mg_enviado'))
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/SendAlert',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                setTimeout(this.clear, 3000)
                if(this.btn_disabled === false){
                   this.btn_disabled = true
                   console.log('Boton Deshabilitado')
                   console.log(this.btn_disabled)
                  setTimeout(() => {
                      this.btn_disabled = false
                      console.log('Boton Activado')
                      console.log(this.btn_disabled)
                  }, 60000)
                }
            },
            clear(){
                this.loading = false
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_activate_false')
            }
        }
    }
</script>

<style scoped>

</style>
